import { buildApiUrl, sendGetRequest, Type } from '@/api/api'
import { assertSchemaAndReturn } from '@/helpers/assert-schema'
import { z } from 'zod'
import * as validation from '@/helpers/validation'
import { TariffsSchema, UtilityProvidersSchema } from './schemas';

function isAdditionalCharge(chargeId: number) {
  return chargeId > 6;
}

export async function getUtilities(countryId: number|undefined = undefined) {
  const url = buildApiUrl(Type.TariffManagement, 'providers')

  if (countryId) {
    url.searchParams.set('countryId', countryId.toString())
  }

  const { data } = await sendGetRequest(url)
  return assertSchemaAndReturn(
    data,
    UtilityProvidersSchema
  )
}

export async function getTariffsByUtilityId(utilityId: number) {

  const { data } = await sendGetRequest(buildApiUrl(Type.TariffManagement, `tariffs?providerId=${utilityId}`))
  const tariffs = assertSchemaAndReturn(
    data,
    TariffsSchema
  )

  return tariffs.map(
    tariff => ({
      id: tariff.id,
      name: tariff.name + ' - ' + tariff.periods[0].yearOfTariff,
      isTimeOfUse: tariff.isTimeOfUse,
      additionalCharges: tariff.periods
        .filter(x => isAdditionalCharge(x.chargeNameId))
        .map(
          period => ({
            id: period.id,
            name: period.chargeName,
            rateInCents: period.bandRateInCents,
            seasonId: period.seasonId,
            seasonName: period.season,
            year: period.yearOfTariff,
          })
        ),
      bands: tariff.periods
        .filter(x => !isAdditionalCharge(x.chargeNameId))
        .map(
          period => ({
            id: period.id,
            name: tariff.isTimeOfUse
              ? period.timeOfUse ?? 'Unknown'
              : period.chargeName,
            seasonId: period.seasonId,
            seasonName: period.season,
            rangeStart: period.startOfBand,
            rangeEnd: period.endOfBand,
            rateInCents: period.bandRateInCents,
            year: period.yearOfTariff,
          })
        )
    })
  )
}
